import Vue from 'vue'
import $ from 'jquery'
// eslint-disable-next-line
import slick from 'slick-carousel'

const SliderTestimonialsDirective = Vue.directive('slider-testimonials-directive', {
  bind (el) {
    $(document).ready(function () {
      const slider = $(el)
      slider.slick({
        arrows: true,
        autoplay: true,
        speed: 3000,
        fade: false,
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false
            }
          }
        ]
      })
    })
  }
})

export default SliderTestimonialsDirective



// WEBPACK FOOTER //
// ./src/components/slider/slider-testimonials/slider-testimonials.directive.js